(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mz-home-community"]) return;
  try {
    
(function(){
  function enhance(){
    document.querySelectorAll('.mh-community').forEach(function(section){
      var feed=section.querySelector('.instafeed-new-layout-container');
      if(!feed)return;
      var instance=window.InstafeedAPI?.settings?.instances?.[feed.dataset.feedId];
      if(window.matchMedia('(max-width:767px)').matches&&instance&&Number(instance.options.columnsMobile)!==6){
        instance.options.columnsMobile=6;
        instance.options.rowsMobile=1;
        instance.run();
        return;
      }
      var track=feed.querySelector('.instafeed-new-layout-wrapper');
      var controls=section.querySelector('.mh-instagram-controls');
      if(!track||!controls)return;
      feed.setAttribute('data-instafeed-prevent-touch-scroll','false');
      var items=Array.from(track.querySelectorAll('.instafeed-new-layout-item'));
      controls.hidden=items.length<2;
      var prev=controls.querySelector('[data-mh-instagram-prev]');
      var next=controls.querySelector('[data-mh-instagram-next]');
      function position(){
        var rect=track.getBoundingClientRect();
        var index=items.reduce(function(best,item,i){return Math.abs(item.getBoundingClientRect().left-rect.left)<Math.abs(items[best].getBoundingClientRect().left-rect.left)?i:best},0);
        if(track.scrollLeft>=track.scrollWidth-track.clientWidth-2)index=items.length-1;
        controls.querySelector('[data-mh-instagram-position]').textContent=(index+1)+' / '+items.length;
        prev.disabled=track.scrollLeft<2;
        next.disabled=track.scrollLeft>=track.scrollWidth-track.clientWidth-2;
      }
      function move(direction){
        track.scrollBy({left:direction*(items[0].getBoundingClientRect().width+10),behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'});
      }
      prev.onclick=function(){move(-1)};
      next.onclick=function(){move(1)};
      if(!track.dataset.mhCarousel){track.dataset.mhCarousel='true';track.addEventListener('scroll',position,{passive:true});}
      position();
    });
  }
  document.addEventListener('instafeedAppLoaded',enhance);
  document.addEventListener('shopify:section:load',enhance);
  enhance();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mz-home-preview"] && !Shopify.designMode) return;
  try {
    
(()=>{const root=document.getElementById('mz-home-preview');if(!root)return;const track=root.querySelector('.mh-product-grid'),buttons=[...root.querySelectorAll('[data-mh-direction]')];const sync=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.mhDirection)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.mhDirection)*(track.clientWidth+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));track.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();})();

(()=>{
  const root=document.querySelector('#mz-home-preview .mh-campaign');
  if(!root)return;
  const track=root.querySelector('.mh-campaign-track'),tabs=[...root.querySelectorAll('[data-campaign-index]')],slides=[...track.children],toggle=root.querySelector('[data-campaign-autoplay]'),motion=matchMedia('(prefers-reduced-motion: reduce)');
  const hero=slides[0].querySelector('img');
  let heroReady=hero.complete;
  let index=0,timer,visible=false,hovered=false,touching=false,paused=motion.matches;
  const stop=()=>clearTimeout(timer);
  const schedule=()=>{
    stop();
    if(!heroReady||paused||hovered||touching||!visible||document.hidden)return;
    timer=setTimeout(()=>go(index+1),3000);
  };
  const heroLoaded=()=>{heroReady=true;schedule();};
  hero.addEventListener('load',heroLoaded,{once:true});
  hero.addEventListener('error',heroLoaded,{once:true});
  const go=i=>{
    index=(i+slides.length)%slides.length;
    track.scrollTo({left:index*track.clientWidth,behavior:motion.matches?'instant':'smooth'});
    schedule();
  };
  const sync=()=>{
    if(!track.clientWidth)return;
    index=Math.round(track.scrollLeft/track.clientWidth);
    tabs.forEach((b,i)=>i===index?b.setAttribute('aria-current','true'):b.removeAttribute('aria-current'));
    slides.forEach((s,i)=>{s.setAttribute('aria-label',`${i+1} de ${slides.length}`);s.querySelectorAll('a').forEach(a=>{a.tabIndex=i===index?0:-1;});});
  };
  const renderToggle=()=>{
    toggle.setAttribute('aria-label',paused?'Reanudar banners automáticos':'Pausar banners automáticos');
    toggle.querySelector('[data-campaign-pause]').style.display=paused?'none':'';
    toggle.querySelector('[data-campaign-play]').style.display=paused?'':'none';
  };
  toggle.addEventListener('click',()=>{paused=!paused;renderToggle();schedule();});
  tabs.forEach((b,i)=>b.addEventListener('click',()=>go(i)));
  root.querySelectorAll('[data-campaign-step]').forEach(b=>b.addEventListener('click',()=>go(index+Number(b.dataset.campaignStep))));
  track.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();go(index+(e.key==='ArrowRight'?1:-1));}});
  track.addEventListener('scroll',sync,{passive:true});
  root.addEventListener('pointerenter',e=>{if(e.pointerType==='mouse'){hovered=true;stop();}});
  root.addEventListener('pointerleave',e=>{if(e.pointerType==='mouse'){hovered=false;schedule();}});
  track.addEventListener('pointerdown',()=>{touching=true;stop();});
  window.addEventListener('pointerup',()=>{if(touching){touching=false;schedule();}});
  window.addEventListener('pointercancel',()=>{touching=false;schedule();});
  root.addEventListener('focusin',e=>{if(e.target!==toggle){paused=true;renderToggle();stop();}});
  document.addEventListener('visibilitychange',schedule);
  motion.addEventListener('change',()=>{paused=motion.matches;renderToggle();schedule();});
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;schedule();},{threshold:0.25});
  observer.observe(root);
  window.addEventListener('resize',()=>{track.scrollTo({left:index*track.clientWidth,behavior:'instant'});sync();schedule();});
  renderToggle();sync();schedule();
})();


(()=>{const root=document.getElementById('mz-home-preview');if(!root)return;const track=root.querySelector('.mh-sports'),buttons=[...root.querySelectorAll('[data-mh-sport-step]')];const sync=()=>buttons.forEach(b=>b.disabled=Number(b.dataset.mhSportStep)<0?track.scrollLeft<2:track.scrollLeft+track.clientWidth>=track.scrollWidth-2);buttons.forEach(b=>b.addEventListener('click',()=>track.scrollBy({left:Number(b.dataset.mhSportStep)*(track.clientWidth+15),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'})));track.addEventListener('scroll',sync,{passive:true});window.addEventListener('resize',sync);sync();})();

  } catch(e) { console.error(e); }
})();
})();
